import { render, staticRenderFns } from "./ServeListItem.vue?vue&type=template&id=3ef5d5a6&scoped=true"
import script from "./ServeListItem.vue?vue&type=script&lang=js"
export * from "./ServeListItem.vue?vue&type=script&lang=js"
import style0 from "./ServeListItem.vue?vue&type=style&index=0&id=3ef5d5a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef5d5a6",
  null
  
)

export default component.exports